import { apiClient } from '@/lib/apiClient';

export interface LeadActivityStatsResponse {
  total: number;
  stale_days_threshold: number;
  pipeline_stages: Record<string, number>;
  stale_leads: number;
  never_contacted: number;
  stale_no_phone: number;
  stale_no_email: number;
  activity_recency: {
    no_activity_date: number;
    older_than_30d: number;
    days_14_30: number;
    days_7_14: number;
    days_2_7: number;
    last_2_days: number;
  };
}

export const leadActivityStatsApi = {
  getStats: (userId: number): Promise<LeadActivityStatsResponse> =>
    apiClient.get(`/leadsys/activity-stats?user_id=${userId}`),
};
